var _title, _desc, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReviewMonitorActive = function SvgReviewMonitorActive(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic-review monitor")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gosite-SVG-Icons",
    transform: "translate(-539.000000, -364.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-review-monitor",
    transform: "translate(539.000000, 364.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#0258FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "4 13.378418 8.05001 8.9453125 12.10002 11.8745117 15.9389648 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,0 C18.8807119,-2.53632657e-16 20,1.11928813 20,2.5 L20,17.5 C20,18.8807119 18.8807119,20 17.5,20 L2.5,20 C1.11928813,20 1.69088438e-16,18.8807119 0,17.5 L0,2.5 C-1.69088438e-16,1.11928813 1.11928813,2.53632657e-16 2.5,0 L17.5,0 Z M17.5,1.5 L2.5,1.5 C1.94771525,1.5 1.5,1.94771525 1.5,2.5 L1.5,2.5 L1.5,17.5 C1.5,18.0522847 1.94771525,18.5 2.5,18.5 L2.5,18.5 L17.5,18.5 C18.0522847,18.5 18.5,18.0522847 18.5,17.5 L18.5,17.5 L18.5,2.5 C18.5,1.94771525 18.0522847,1.5 17.5,1.5 L17.5,1.5 Z",
    id: "Combined-Shape",
    fill: "#0A1E3B"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReviewMonitorActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/review-monitor-active.a5151879.svg";
export { ForwardRef as ReactComponent };